import { Flex } from '@chakra-ui/react';
import { SpinnerIcon } from './spinner-icon';

export const FullPageSpinner = () => (
  <Flex position='absolute' top='0' left='0' width='100vw' h='100vh' background='white' align='center' justify='center'>
    <SpinnerIcon />
  </Flex>
);
